import * as S from './styles'

export const ToastContent = ({ title, body }) => (
  <S.InfoMessageDiv>
    <S.MessageTitle>{title}</S.MessageTitle>
    {body}
  </S.InfoMessageDiv>
)
